import axios from 'axios';

export const generateAxiosInstanceTeacher = () => {
  const baseURL = process.env.REACT_APP_BACKEND_TEACHER_URL; // Your base URL
  const accessToken = localStorage.getItem('accessToken');
  return axios.create({
    baseURL,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  });
};